// Note, constants are replaced right after tsc built the project.
// Update scripts/post-build.ts when requirements here change.
export const pkg = {
    name: 'magicbell',
    version: '4.5.1',
};
//# sourceMappingURL=pkg.js.map